<template>
  <div style="direction: ltr;" class="component-products-list">
     <Carousel
       :rtl="$store.getters['tenantConfig/isRTL']"
       :auto-width="true"
       :margin="8"
       :loop="true"
       :rewind="true"
       :items="5"
       :dots="false">
       <ProductCard v-for="(item, index) in items" :key="index" :item="item"/>
     </Carousel>
   </div>
</template>

<style>
.owl-item {
  padding-bottom: 5px;
}
</style>
<script>
import ProductCard from '@/components/ProductCard.vue'
import enums from '@/utilities/enums.js'
import Carousel from '@/components/Carousel.vue'

export default {
  name: 'ProductsList',
  components: {
    ProductCard,
    Carousel
  },
  mixins: [enums],
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cardWidth: '',
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
